import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Instagram, Globe2 } from 'lucide-react';
import SLBSLogo from './SLBSLogo';
import TrustBadge from './TrustBadge';

const Footer = () => {
  return (
    <footer className="bg-[#4A4A4A] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <SLBSLogo 
                variant="compact" 
                linkTo="/" 
                isFooter={true}
                className=""
              />
            </div>
            <p className="flex items-center gap-2 text-gray-100 text-sm font-semibold mb-2">
              <Globe2 size={16} className="flex-shrink-0" style={{ color: '#F7C9D3' }} />
              Helping Businesses Thrive in Japan and Beyond.
            </p>
            <p className="text-gray-400 text-xs leading-relaxed mb-4">
              Empowering Japanese businesses to reach the world, and helping global businesses succeed in Japan through bilingual expertise, AI-powered marketing, digital transformation, and strategic business partnerships.
            </p>
            <div className="mb-4">
              <TrustBadge variant="dark" />
            </div>
            <div className="space-y-2 text-sm">
              <div className="flex items-center space-x-2">
                <Mail size={16} />
                <span>info@sakura-local.jp</span>
              </div>
              <div className="flex items-center space-x-2">
                <MapPin size={16} />
                <span>兵庫県赤穂郡上郡町</span>
              </div>
              <div className="flex items-center space-x-2">
                <Instagram size={16} />
                <a 
                  href="https://www.instagram.com/sakura.local" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-[#F7C9D3] transition-colors"
                >
                  @sakura.local
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4">サービス</h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>
                <Link to="/services/web" className="hover:text-[#F7C9D3] transition-colors">
                  Webサイト制作
                </Link>
              </li>
              <li>
                <Link to="/services/sns" className="hover:text-[#F7C9D3] transition-colors">
                  SNS運用サポート
                </Link>
              </li>
              <li>
                <Link to="/services/tiktok-live" className="hover:text-[#F7C9D3] transition-colors">
                  TikTok LIVE・ライブ配信サポート
                </Link>
              </li>
              <li>
                <Link to="/services/marketing" className="hover:text-[#F7C9D3] transition-colors">
                  マーケティングサポート
                </Link>
              </li>
              <li>
                <Link to="/global-business" className="hover:text-[#F7C9D3] transition-colors">
                  Global Business Solutions
                </Link>
              </li>
              <li>
                <Link to="/services/consulting" className="hover:text-[#F7C9D3] transition-colors">
                  ビジネスコンサルティング
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="hover:text-[#F7C9D3] transition-colors">
                  料金
                </Link>
              </li>
              <li>
                <Link to="/news" className="hover:text-[#F7C9D3] transition-colors">
                  お知らせ
                </Link>
              </li>
            </ul>
          </div>

          {/* Service Area */}
          <div>
            <h3 className="font-semibold mb-4">対応エリア</h3>
            <p className="text-sm text-gray-300 mb-2">
              上郡町・赤穂市・たつの市・相生市
            </p>
            <p className="text-xs text-gray-400 mb-4">
              ※ Webサイト制作・ホスティングのみの場合は、SNS経由で全国対応しています。
            </p>
            <h3 className="font-semibold mb-2 mt-6">お問い合わせ</h3>
            <p className="text-sm text-gray-300 mb-3">
              Webサイトの管理・更新もすべておまかせいただけます。
            </p>
            <Link 
              to="/contact" 
              className="inline-block btn-secondary px-6 py-2 rounded-full text-sm font-medium cursor-pointer"
              style={{ pointerEvents: 'auto', position: 'relative', zIndex: 10 }}
            >
              無料相談はこちら
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-600 mt-8 pt-6 text-sm text-gray-400">
          <p className="text-gray-300 mb-4 text-sm">
            Sakura Local Business Support（SLBS）は、さくらグローバル合同会社（Sakura Global LLC）が運営しています。
          </p>
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p>© {new Date().getFullYear()} Sakura Local Business Support. All Rights Reserved.</p>
            <div className="flex space-x-6">
              <Link to="/privacy" className="hover:text-[#F7C9D3] transition-colors">
                プライバシーポリシー
              </Link>
              <Link to="/terms" className="hover:text-[#F7C9D3] transition-colors">
                利用規約
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;